var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitcoinDisable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Bitcoin"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e8",
    d: "M47 32v14h-2v3h-2v4H21v-4h-2v-3h-2V32h2v-3h1v-4h24v4h1v3z",
    opacity: 1,
    "data-original": "#e6e7e8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d4d7",
    d: "M20 29v-4H8v4h11z",
    opacity: 1,
    "data-original": "#9bc9ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M19 32v-3H9v3h8z",
    opacity: 1,
    "data-original": "#bddbff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d4d7",
    d: "M21 49H7v4h14z",
    opacity: 1,
    "data-original": "#9bc9ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M19 46H9v3h10z",
    opacity: 1,
    "data-original": "#bddbff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcc7cf",
    d: "M11 32h6v14h-6z",
    opacity: 1,
    "data-original": "#c2dff6",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d4d7",
    d: "M59 53H5v4h54z",
    opacity: 1,
    "data-original": "#57a4ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcc7cf",
    d: "M5 57H3v4h58v-4h-2z",
    opacity: 1,
    "data-original": "#2488ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d4d7",
    d: "M45 29h11v-4H44v4z",
    opacity: 1,
    "data-original": "#9bc9ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M45 32h10v-3H45z",
    opacity: 1,
    "data-original": "#bddbff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d4d7",
    d: "M43 49v4h14v-4H45z",
    opacity: 1,
    "data-original": "#9bc9ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M45 46v3h10v-3h-8z",
    opacity: 1,
    "data-original": "#bddbff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcc7cf",
    d: "M47 32h6v14h-6z",
    opacity: 1,
    "data-original": "#c2dff6",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 39,
    r: 11,
    fill: "#fbb040",
    opacity: 1,
    "data-original": "#fbb040",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7941d",
    d: "M32 28c-.338 0-.67.021-1 .05a11 11 0 0 1 0 21.9c.33.029.662.05 1 .05a11 11 0 0 0 0-22z",
    opacity: 1,
    "data-original": "#f7941d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d4d7",
    d: "M6 20h52v5H6z",
    opacity: 1,
    "data-original": "#57a4ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d4d7",
    d: "M50 32h3v14h-3zM14 32h3v14h-3z",
    opacity: 1,
    "data-original": "#96c8ef",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d4d7",
    d: "M6 20h52v2H6z",
    opacity: 1,
    "data-original": "#4e94e5",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M58 20H6L32 6z",
    opacity: 1,
    "data-original": "#bddbff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 14,
    r: 3,
    fill: "#f1f2f2",
    opacity: 1,
    "data-original": "#f1f2f2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d4d7",
    d: "M60.1 18.5 32 3 3.905 18.5A1.751 1.751 0 0 0 3 20.033a1.75 1.75 0 0 0 2.6 1.532L32 7l26.405 14.568A1.75 1.75 0 0 0 61 20.036a1.751 1.751 0 0 0-.9-1.536z",
    opacity: 1,
    "data-original": "#57a4ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcc7cf",
    d: "M44 25h12v2H44zM8 25h12v2H8z",
    opacity: 1,
    "data-original": "#8cb5e5",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d4d7",
    d: "M5 53h54v2H5z",
    opacity: 1,
    "data-original": "#4e94e5",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M3 57h58v2H3z",
    opacity: 1,
    "data-original": "#207ae5",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1f2f2",
    d: "M14 34a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0-1-1zM50 34a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0-1-1z",
    opacity: 1,
    "data-original": "#f1f2f2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef4136",
    d: "M36.618 39A3.983 3.983 0 0 0 34 32v-1a1 1 0 0 0-2 0v1h-1.017c0-.31.009-.657.017-.977A1 1 0 0 0 30.023 30a.975.975 0 0 0-1.023.977c-.01.417-.016.739-.02 1.023H27a1 1 0 0 0 0 2h1v10h-1a1 1 0 0 0 0 2h2v1a1 1 0 0 0 2 0v-1h1v1a1 1 0 0 0 2 0v-1a3.983 3.983 0 0 0 2.618-7zM36 36a2 2 0 0 1-2 2h-4v-4h4a2 2 0 0 1 2 2zm-2 8h-4v-4h4a2 2 0 0 1 0 4z",
    opacity: 1,
    "data-original": "#ef4136",
    className: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinDisable);
export default __webpack_public_path__ + "static/media/bitcoinDisable.530b94bc9ee3a4803f01efc75febb723.svg";
export { ForwardRef as ReactComponent };